import { margin } from "@mui/system";
import React from "react";
import DotsComponent from "../../DotsComponent";
import "../IDcard/IDCard.css";
import DeleteIcon from '@mui/icons-material/Delete';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IOSSwitch } from "./teamsIDCard";

const TeamsDetailsCard = () => {
  return (
    <>
      <div className="teamcontainer" >
      <DotsComponent/>
        <div style={{ textAlign: "center", padding: "5px" }}>
          <small>Teams details</small>
        </div>
        <div className="teamsubcontainer">
          <div className="active">
          <div className="active-text"> Active</div>
          </div>

          <div className="allDetailsBox">
          
            <div>
              <div className="customername">
                <span>Customer Name Here</span>
                <small style={{ fontSize: "12px" }}>
                  Signed-in On: 18th Aug 2022{" "}
                </small>
              </div>

              <div className="details">
                <span>
                  Ordered: <b>Jon Aches</b>
                </span>
                <label>Email ID :jonach.123@gmail.com </label>
                <span>
                  {" "}
                  Contact details: <b>+91-7833516223</b>
                </span>
                <span>
                  {" "}
                  Amount: Rs.<b>98000</b>
                </span>
                <span>
                  {" "}
                  Delivery: <b>Successfull</b>
                </span>
              </div>
            </div>
            <div className="crm-toggle">
            <FormControlLabel
        control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
      />
      </div>
          </div>
          <div
            style={{
              textDecoration: "underline",
              textAlign:'right',
              marginTop:'5px',display:'flex',
              justifyContent:'space-between', color:'#7E7E7E'
            }}
          ><small style={{margin:'12px'}}>Send mail now</small> 
          <div style={{margin:'8px', alignItems:'right'}}><DeleteIcon style={{color:"#F24E1E"}}/></div>
          
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamsDetailsCard;
